import React, { useEffect, useState }        from 'react';
import BurgerRow    from '../burger-row';
import ArrowIcon    from 'assets/icons/arrow-left-blue.svg';
import * as Routes from 'constants/routes';
import './index.scss';
import { useSelector } from 'react-redux';
import AnalyticsManager from 'app/analytics';
import { generateUniqueId, sortArrayByKey } from 'app/functions';
import { NavLink, useHistory } from 'react-router-dom';

const SubMenu = (props) => {
    const { sub, onClose } = props;
    const history = useHistory();
    const megaMenu = useSelector(store => store.config.megaMenu);
    const MAX_CATEGORIES = useSelector(store => store.config.megaMenuMaxCategories);
    const MAX_SUB_CATEGORIES = useSelector(store => store.config.megaMenuMaxSubCategories);
    const translations = useSelector((store) => store.config.Translations);
    const [selectedSub, setSelectedSub] = useState(null);
    const title = sub?.title;
    const subtitle = sub?.subtitle;

    const handleAllBenefitsClick = () => AnalyticsManager.logMenuItemPress(translations['mega_menu_all_benefits']);
    
    useEffect(() => {
        if(sub === null){
            onClose();
            setSelectedSub(null);
        }
    }, [sub]);

    const setSubMenu = (id, title, subs) => { 
        if(selectedSub?.id === id){
            setSelectedSub(null);
        } else {
            setSelectedSub({ 
                id: id, 
                title: subtitle, 
                subtitle: title,
                subCats: subs
            });
        }
    };

    let rowsArr = [];

    if(!sub?.subCats){
        let megaMenuKey  = undefined;

        if (sub?.id === 0) megaMenuKey = 'shopping_categories';
        if (sub?.id === 1) megaMenuKey = 'smart_consuming';
        if (sub?.id === 2) megaMenuKey = 'actions';

        megaMenuKey && sortArrayByKey(Object.values(megaMenu[megaMenuKey])).forEach((subCatData, index) => {
            const rightIcon = (megaMenuKey !== 'actions') && (subCatData.icon || subCatData.imagePath);
            const subCatsList = (subCatData.subCatsArr || subCatData.sub_itemsArr);

            let handleClick = () => {
                AnalyticsManager.logMenuItemPress(subCatData.title);
                history.push(subCatData.path);
            }

            if (subCatData.link) {
                if (subCatData.link.type === 'external') {
                    handleClick = () => {
                        AnalyticsManager.logMenuItemPress(subCatData.title);
                        window.location = subCatData.link.route;
                    }
                } else {
                    handleClick = () => {
                        AnalyticsManager.logMenuItemPress(subCatData.title);
                        history.push(Routes[subCatData.link.route]);
                    }
                }
            }

            if (subCatData.searchParams) {
                handleClick = () => history.push(`${Routes.category}/${subCatData.id}/${subCatData.searchParams.category}`);
            }

            if (subCatsList?.length > 0) {
                handleClick = () => setSubMenu(subCatData.id, subCatData.title, subCatsList);
            }

            // Limit the number of categories that can be shown (same as the mega-menu on desktop)
            if (megaMenuKey === 'shopping_categories' && index >= MAX_CATEGORIES) {
                return;
            }

            rowsArr.push(
                <BurgerRow
                    key={`${megaMenuKey}-${subCatData.id}`}
                    className="category"
                    text={subCatData.title}
                    rightIcon={rightIcon}
                    icon={subCatsList?.length > 0 ? ArrowIcon : null}
                    onClick={handleClick}
                />
            );
        });
    } else {
        sub.subCats.forEach((cat, idx) => {
            if(idx < MAX_SUB_CATEGORIES){
                let categoryLink;

                if (cat?.searchParams?.category) {
                    categoryLink = `${Routes.category}/${cat.id}/${cat.searchParams.category}`;
                }

                const handleSubCategoryClick = () => AnalyticsManager.logMenuSubCategoryPress(cat.id, cat.title);

                rowsArr.push(
                    <BurgerRow
                        key={generateUniqueId(7)}
                        className="category"
                        id={cat.id}
                        text={cat.title}
                        externalLink={cat.externalLink}
                        internalLink={categoryLink}
                        onClick={handleSubCategoryClick}
                    />
                )
            }
        })
    }

    const openClassName = sub !== null ? "open":"";
    return (
        <div className={`sub-menu-wrapper ${openClassName}`}>
            <div className="sub-menu">
                <BurgerRow className="row link" onClick={onClose.bind(this, sub?.id)}>
                    <div className="right">
                        <div className="arrow-wrapper">
                            <img src={ArrowIcon} alt="/" className="arrow" />
                        </div>
                        <span className="title">{title}</span>
                    </div>
                </BurgerRow>
                <BurgerRow className="row">
                    <div className="right">
                        <span className="subtitle">{subtitle}</span>
                    </div>
                    <div className="left">
                        {sub?.id === 0 && (
                            <NavLink to={Routes.benefits} className="see-more-btn" onClick={handleAllBenefitsClick}>
                                {translations['mega_menu_all_benefits']}
                            </NavLink>
                        )}
                    </div>
                </BurgerRow>
                {rowsArr}
            </div>
            {sub && <SubMenu sub={selectedSub} onClose={setSubMenu}/>}
        </div>);
};

export default SubMenu;
